module.exports = "<app-popular-news></app-popular-news>\n<app-basic-info></app-basic-info> \n"